const FooterData = [
  {
    title: 'Company',
    description: ['Team', 'Contact us'],
  },
  {
    title: 'Features',
    description: ['Articles', 'Rich editor'],
  },
  {
    title: 'Resources',
    description: ['Documentation', 'API'],
  },
  {
    title: 'Legal',
    description: ['Privacy policy', 'Terms of use'],
  },
];

export default FooterData;
